exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr td:nth-child(3) {\n  /* width: 120px; */\n}\ntr td:nth-child(4) {\n  /* width: 90px; */\n}\n", ""]);

// exports
